var $ = require('jquery');
var IsTouch = require('./IsTouch');

class SmoothScroll {
    constructor(selector, options) {
        this.$scrollContainer = $(selector);

        this.options = options || {
                scrollTime: .3,
                scrollDistance: 50
            }
    }

    init() {
        this.bind();
    }

    smoothScrollLogicCallback() {
        return (event) => {
            event.preventDefault();

            let delta = event.originalEvent.wheelDelta / 120 || -event.originalEvent.detail / 3;
            let scrollTop = this.$scrollContainer.scrollTop();
            let finalScroll = scrollTop - parseInt(delta * this.options.scrollDistance);

            TweenMax.to(this.$scrollContainer, this.options.scrollTime, {
                scrollTo: {y: finalScroll, autoKill: true},
                ease: Power1.easeOut,
                overwrite: 5
            });
        }
    }

    unbind() {
        if (!IsTouch()) {
            $(window).off("mousewheel DOMMouseScroll");
        }
    }

    bind() {
        if (!IsTouch()) {
            $(window).on("mousewheel DOMMouseScroll", this.smoothScrollLogicCallback());
        }
    }
}

module.exports = SmoothScroll;